export default function LeadTabs({
  activeTab,
  onChange,
  historyCount,
}) {
  return (
    <div className="mt-4 flex border-b border-slate-200">
      <Tab
        active={
          activeTab === "action"
        }
        onClick={() =>
          onChange("action")
        }
      >
        Action
      </Tab>

      <Tab
        active={
          activeTab === "history"
        }
        onClick={() =>
          onChange("history")
        }
      >
        History

        {historyCount > 0 && (
          <span className="ml-1.5 rounded-full bg-slate-100 px-1.5 py-0.5 text-[10px]">
            {historyCount}
          </span>
        )}
      </Tab>
    </div>
  );
}

function Tab({
  active,
  onClick,
  children,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center border-b-2 px-3 py-2 text-xs font-semibold transition ${
        active
          ? "border-slate-900 text-slate-900"
          : "border-transparent text-slate-400 hover:text-slate-700"
      }`}
    >
      {children}
    </button>
  );
}